import { render, staticRenderFns } from "./CartPage.vue?vue&type=template&id=a555508c&"
import script from "./CartPage.vue?vue&type=script&lang=js&"
export * from "./CartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a555508c')) {
      api.createRecord('a555508c', component.options)
    } else {
      api.reload('a555508c', component.options)
    }
    module.hot.accept("./CartPage.vue?vue&type=template&id=a555508c&", function () {
      api.rerender('a555508c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/CartPage.vue"
export default component.exports